export class StickyElement {
  constructor(target) {
    this.target = target;
    this.setStickyElement();

    window.onscroll = () => {
      this.setStickyElement();
    };
  }

  setStickyElement() {
    (window.pageYOffset >= 1) ?
      this.target.classList.add('sticky') :
      this.target.classList.remove('sticky');
  }
}
